import { Maybe } from 'prismic-types';
import {
  IconClose,
  IconError,
  IconWarning,
  IconSuccess,
  IconInformation,
} from 'components/icon/Icon';
import { RichTextField } from '@prismicio/types';
import { RichText } from 'components/rich-text/RichText';
import { colors } from './colors';
import c from 'classnames';

import s from './Banner.module.scss';

export type BannerType = 'Information' | 'Success' | 'Warning' | 'Error';

const getStyleAndIcon = (bannerType?: BannerType) => {
  const { blue, red, green, yellow } = colors;

  if (!bannerType) {
    return;
  }
  if (bannerType === 'Information') {
    return {
      style: {
        backgroundColor: blue.bg,
        color: blue.text,
      },
      icon: <IconInformation />,
    };
  }
  if (bannerType === 'Error') {
    return {
      style: {
        backgroundColor: red.bg,
        color: red.text,
      },
      icon: <IconError />,
    };
  }
  if (bannerType === 'Success') {
    return {
      style: {
        backgroundColor: green.bg,
        color: green.text,
      },
      icon: <IconSuccess />,
    };
  }
  if (bannerType === 'Warning') {
    return {
      style: {
        backgroundColor: yellow.bg,
        color: yellow.text,
      },
      icon: <IconWarning />,
    };
  }
};

type Props = {
  bannerRef: React.RefObject<HTMLDivElement>;
  onClick: () => void;
  title?: Maybe<string>;
  description?: RichTextField;
  type?: BannerType;
};

export const Banner = ({
  title,
  description,
  type,
  onClick,
  bannerRef,
}: Props) => (
  <div
    ref={bannerRef}
    className={s.banner}
    style={getStyleAndIcon(type)?.style}
  >
    <div className={s.container}>
      <div className={c(s.info, { [s.noTitle]: !title })}>
        <div className={s.heading}>
          <div className={s.icon}>{getStyleAndIcon(type)?.icon}</div>
          {title && (
            <>
              <p className={s.title}>{title}</p>
              <div className={s.dot}>·</div>
            </>
          )}
        </div>
        {description && (
          <RichText className={s.description}>{description}</RichText>
        )}
      </div>

      <button
        onClick={onClick}
        tabIndex={0}
        aria-label="close"
        className={s.button}
      >
        <div>
          <IconClose />
        </div>
      </button>
    </div>
  </div>
);
